
import React, { createContext, useState, useEffect } from "react";

export const QuoteContext = createContext();

export const QuoteProvider = ({ children }) => {
  const steps = ["Coverage", "Age", "Residency", "Plans", "Summary"];

  // Load data from localStorage or set defaults
  const getStoredData = (key, defaultValue) => {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  };

  const [step, setStep] = useState(getStoredData("quoteStep", 1));
  const [formValues, setFormValues] = useState(getStoredData("quoteFormValues", {}));

  // Save formValues and step to localStorage when they change
  useEffect(() => {
    localStorage.setItem("quoteStep", JSON.stringify(step));
  }, [step]);

  useEffect(() => {
    localStorage.setItem("quoteFormValues", JSON.stringify(formValues));
  }, [formValues]);

  const resetQuoteForm = () => {
    setStep(1);
    setFormValues({});
    localStorage.removeItem("quoteStep");
    localStorage.removeItem("quoteFormValues");
  };

  const nextStep = () => setStep((prev) => Math.min(prev + 1, steps.length));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));
  const updateFormValues = (newValues) => {
    setFormValues((prev) => ({ ...prev, ...newValues }));
  };

  return (
    <QuoteContext.Provider value={{ step, steps, nextStep, prevStep, updateFormValues, formValues , resetQuoteForm }}>
      {children}
    </QuoteContext.Provider>
  );
};
